import { combineReducers } from 'redux'

import scopeDropdown from './scope_dropdown'

export default combineReducers({
  scope_dropdown: scopeDropdown
})
